// extracted by mini-css-extract-plugin
export default {"footer-email-container":"YleVLzC48T_omf7ndCy6","footerEmailContainer":"YleVLzC48T_omf7ndCy6"};